import { useEffect, useRef, useState } from 'react';
import sendMyCarUpdate from '../../../../api/bank/sendMyCarUpdate';
import Button from '../../../../components/Button/Button';
import alert from '../../../../helpers/alert';
import extractErrorMessage from '../../../../utils/extractErrorMessage';

// ÐÐ¾Ð´Ñ ÑÐ¸Ð¿Ð¾Ð² Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ¾Ð² MyCar (Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ°ÑÐ¸Ñ MCFLeadGenerationService B2C 09.2026).
// Â«ÐÑÑÐ³Ð¾Ð¹ Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÂ» Ð¿ÐµÑÐ²ÑÐ¼: ÑÐ°ÑÐµ Ð²ÑÐµÐ³Ð¾ Ð±Ð°Ð½Ðº Ð¿ÑÐ¾ÑÐ¸Ñ Ð¸Ð¼ÐµÐ½Ð½Ð¾ ÑÐ¾, ÑÐµÐ³Ð¾ Ð½ÐµÑ Ð² ÑÐ¿Ð¸ÑÐºÐµ.
export const MYCAR_DOCUMENT_TYPES = [
  { value: 'OtherDocumentsLeadGenerator', label: 'ÐÑÑÐ³Ð¾Ð¹ Ð´Ð¾ÐºÑÐ¼ÐµÐ½Ñ' },
  { value: 'StatementCertificate', label: 'ÐÑÐ¿Ð¸ÑÐºÐ°' },
  { value: 'ApplicationForm', label: 'ÐÐ½ÐºÐµÑÐ°' },
  { value: 'CreditBureauAgreement', label: 'Ð¡Ð¾Ð³Ð»Ð°ÑÐ¸Ðµ Ð½Ð° ÑÐ±Ð¾Ñ Ð¸ Ð¾Ð±ÑÐ°Ð±Ð¾ÑÐºÑ Ð´Ð°Ð½Ð½ÑÑ' },
  { value: 'PhotoClient', label: 'Ð¤Ð¾ÑÐ¾ ÐºÐ»Ð¸ÐµÐ½ÑÐ°' },
  { value: 'RegistrationCertificate', label: 'Ð¢ÐµÑÐ¿Ð°ÑÐ¿Ð¾ÑÑ' },
  { value: 'VehicleVerificationReport', label: 'ÐÐºÑ Ð²ÐµÑÐ¸ÑÐ¸ÐºÐ°ÑÐ¸Ð¸ ÑÑÐ°Ð½ÑÐ¿Ð¾ÑÑÐ½Ð¾Ð³Ð¾ ÑÑÐµÐ´ÑÑÐ²Ð°' },
];

/** Ð¢ÐµÐºÑÑ, ÐºÐ¾ÑÐ¾ÑÑÐ¹ ÑÑÐ°Ð²Ð¸Ð¼ Ð·Ð°ÑÐ²ÐºÐµ Ð¿Ð¾ÑÐ»Ðµ Ð¾ÑÐ¿ÑÐ°Ð²ÐºÐ¸ Ð´Ð¾ÑÐ°Ð±Ð¾ÑÐºÐ¸. */
export const MYCAR_REWORK_SENT = 'ÐÐ¾ÑÐ°Ð±Ð¾ÑÐºÐ° Ð¾ÑÐ¿ÑÐ°Ð²Ð»ÐµÐ½Ð° Ð² MyCar, Ð¶Ð´ÑÐ¼ Ð¾ÑÐ²ÐµÑ Ð±Ð°Ð½ÐºÐ°';

/**
 * ÐÐ¾ÑÐ°Ð±Ð¾ÑÐºÐ° ÑÑÐ»Ð°, ÑÐµÑÐµÐ½Ð¸Ðµ Ð±Ð°Ð½ÐºÐ° ÐµÑÑ Ð½Ðµ Ð¿ÑÐ¸ÑÐ»Ð¾. ÐÐ¾ÐºÐ° ÑÐ°Ðº â Ð±Ð°Ð½Ðº Ð½Ðµ Ð¿Ð¾Ð´ÑÐ²ÐµÑÐ´Ð¸Ð»
 * ÑÑÐ»Ð¾Ð²Ð¸Ñ, Ð¸ Ð²ÑÐ±Ð¸ÑÐ°ÑÑ Ð¿ÑÐµÐ´Ð»Ð¾Ð¶ÐµÐ½Ð¸Ðµ ÑÐ°Ð½Ð¾: Ð¾Ð½Ð¾ Ð¼Ð¾Ð¶ÐµÑ Ð¸Ð·Ð¼ÐµÐ½Ð¸ÑÑÑÑ.
 */
export const awaitingMyCarRework = (appeal, mycarBankId) =>
  appeal?.bank?.id === mycarBankId && (appeal?.errorMessage || '').startsWith(MYCAR_REWORK_SENT);

/**
 * ÐÐ°ÑÐ²ÐºÐ° MyCar Ð¶Ð´ÑÑ Ð´Ð¾ÑÐ°Ð±Ð¾ÑÐºÐ¸: Ð±Ð°Ð½Ðº Ð¿ÑÐ¸ÑÐ»Ð°Ð» Â«ÐÐ´Ð¾Ð±ÑÐµÐ½Ð¾ Ñ Ð´Ð¾ÑÐ°Ð±Ð¾ÑÐºÐ¾Ð¹Â» Ð¸ Ð¶Ð´ÑÑ Ð´Ð¾ÐºÑÐ¼ÐµÐ½Ñ.
 * ÐÐ·Ð¼ÐµÐ½ÐµÐ½Ð¸Ðµ ÑÑÐ»Ð¾Ð²Ð¸Ð¹ (Â«ÐÐ´Ð¾Ð±ÑÐµÐ½Ð¾ Ñ ÑÑÐ»Ð¾Ð²Ð¸ÐµÐ¼Â», Ð°Ð»ÑÑÐµÑÐ½Ð°ÑÐ¸Ð²Ð°) ÑÑÐ´Ð° Ð½Ðµ Ð¾ÑÐ½Ð¾ÑÐ¸ÑÑÑ: Ð±Ð°Ð½Ðº
 * (ÐÑÐ½, 24.09.2026) Ð¿Ð¾Ð´ÑÐ²ÐµÑÐ¶Ð´Ð°ÐµÑ ÐµÐ³Ð¾ Ð²ÑÐ±Ð¾ÑÐ¾Ð¼ Ð¿ÑÐµÐ´Ð»Ð¾Ð¶ÐµÐ½Ð¸Ñ â PostClientChoise.
 */
export const needsMyCarUpdate = (appeal, mycarBankId) =>
  appeal?.bank?.id === mycarBankId && /Ð´Ð¾ÑÐ°Ð±Ð¾ÑÐº/i.test(appeal?.errorMessage || '');

/** ÐÐ°Ð½Ðº Ð¾Ð´Ð¾Ð±ÑÐ¸Ð» Ð½Ð° ÑÐ²Ð¾Ð¸Ñ ÑÑÐ»Ð¾Ð²Ð¸ÑÑ: Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑÑ Ð´Ð¾ÑÑÐ°ÑÐ¾ÑÐ½Ð¾ Ð²ÑÐ±ÑÐ°ÑÑ Ð¿ÑÐµÐ´Ð»Ð¾Ð¶ÐµÐ½Ð¸Ðµ. */
export const isMyCarConditionCase = (appeal, mycarBankId) =>
  appeal?.bank?.id === mycarBankId && /Ñ ÑÑÐ»Ð¾Ð²Ð¸ÐµÐ¼/i.test(appeal?.errorMessage || '');

const MyCarUpdateApplication = ({ appealId, onSuccess }) => {
  const [file, setFile] = useState(null);
  const [comment, setComment] = useState('');
  const [documentType, setDocumentType] = useState(MYCAR_DOCUMENT_TYPES[0].value);
  const [loading, setLoading] = useState(false);

  // ÐÑÐ²ÐµÑ Ð±Ð°Ð½ÐºÐ° Ð¿ÑÐ¸ÑÐ¾Ð´Ð¸Ñ ÐºÐ¾Ð»Ð±ÑÐºÐ¾Ð¼, ÑÐ°Ð¼ Ð¿Ð¾ ÑÐµÐ±Ðµ ÑÐºÑÐ°Ð½ ÐµÐ³Ð¾ Ð½Ðµ Ð¿Ð¾ÐºÐ°Ð¶ÐµÑ: Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑÑ
  // Ð¿ÑÐ¸ÑÐ»Ð¾ÑÑ Ð±Ñ Ð¾Ð±Ð½Ð¾Ð²Ð»ÑÑÑ ÑÑÑÐ°Ð½Ð¸ÑÑ. ÐÐ¾ÑÐ»Ðµ Ð¾ÑÐ¿ÑÐ°Ð²ÐºÐ¸ Ð´Ð¾ÑÐ°Ð±Ð¾ÑÐºÐ¸ ÑÐ¸ÑÐ¾ Ð¿ÐµÑÐµÑÐ¸ÑÑÐ²Ð°ÐµÐ¼
  // ÐºÐ°ÑÑÐ¾ÑÐºÑ ÑÐ°Ð· Ð² Ð¼Ð¸Ð½ÑÑÑ Ð² ÑÐµÑÐµÐ½Ð¸Ðµ 20 Ð¼Ð¸Ð½ÑÑ. Ð§Ð°ÑÐµ Ð½ÐµÐ·Ð°ÑÐµÐ¼: Ð±Ð°Ð½Ðº Ð¾ÑÐ²ÐµÑÐ°ÐµÑ
  // Ð¼Ð¸Ð½ÑÑÐ°Ð¼Ð¸, Ð° ÐºÐ°Ð¶Ð´ÑÐ¹ Ð¾Ð¿ÑÐ¾Ñ ÑÑÐ½ÐµÑ Ð²ÑÑ ÐºÐ°ÑÑÐ¾ÑÐºÑ ÑÐ´ÐµÐ»ÐºÐ¸.
  const pollRef = useRef(null);
  useEffect(() => () => clearInterval(pollRef.current), []);
  const startPolling = () => {
    clearInterval(pollRef.current);
    let left = 20;
    pollRef.current = setInterval(() => {
      if (left-- <= 0) {
        clearInterval(pollRef.current);
        return;
      }
      onSuccess && onSuccess();
    }, 60000);
  };

  const send = async () => {
    if (!file && !comment.trim()) {
      alert.error('ÐÑÐ¸Ð»Ð¾Ð¶Ð¸ÑÐµ Ð´Ð¾ÐºÑÐ¼ÐµÐ½Ñ Ð¸Ð»Ð¸ Ð½Ð°Ð¿Ð¸ÑÐ¸ÑÐµ ÐºÐ¾Ð¼Ð¼ÐµÐ½ÑÐ°ÑÐ¸Ð¹ Ð´Ð»Ñ Ð±Ð°Ð½ÐºÐ°');
      return;
    }
    setLoading(true);
    try {
      await sendMyCarUpdate({ appealId, comment: comment.trim(), documentType, file });
      alert.success('ÐÐ¾ÑÐ°Ð±Ð¾ÑÐºÐ° Ð¾ÑÐ¿ÑÐ°Ð²Ð»ÐµÐ½Ð° Ð² MyCar');
      setFile(null);
      setComment('');
      onSuccess && onSuccess();
      startPolling();
    } catch (e) {
      alert.error(extractErrorMessage(e?.response?.data) || 'ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ Ð¾ÑÐ¿ÑÐ°Ð²Ð¸ÑÑ Ð´Ð¾ÑÐ°Ð±Ð¾ÑÐºÑ Ð² MyCar');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ background: '#FFF4E5', padding: '15px 20px', marginBottom: 20 }}>
      <p style={{ fontWeight: 600, marginBottom: 5 }}>ÐÐ¾ÑÐ°Ð±Ð¾ÑÐºÐ° Ð¿Ð¾ Ð·Ð°ÑÐ²ÐºÐµ MyCar</p>
      <p style={{ fontSize: 13, marginBottom: 10 }}>
        ÐÐ°Ð½Ðº Ð¾Ð´Ð¾Ð±ÑÐ¸Ð» Ð·Ð°ÑÐ²ÐºÑ Ð¸ Ð¿ÑÐ¾ÑÐ¸Ñ Ð´Ð¾ÑÐ»Ð°ÑÑ Ð´Ð¾ÐºÑÐ¼ÐµÐ½Ñ. ÐÑÐ±ÐµÑÐ¸ÑÐµ ÑÐ¸Ð¿, Ð¿ÑÐ¸Ð»Ð¾Ð¶Ð¸ÑÐµ ÑÐ°Ð¹Ð» Ð¸ Ð¿ÑÐ¸
        Ð½ÐµÐ¾Ð±ÑÐ¾Ð´Ð¸Ð¼Ð¾ÑÑÐ¸ Ð½Ð°Ð¿Ð¸ÑÐ¸ÑÐµ ÐºÐ¾Ð¼Ð¼ÐµÐ½ÑÐ°ÑÐ¸Ð¹ â Ð²ÑÑ ÑÐ¹Ð´ÑÑ Ð² MyCar Ð¿Ð¾ ÑÑÐ¾Ð¹ Ð¶Ðµ Ð·Ð°ÑÐ²ÐºÐµ.
      </p>
      <select
        aria-label="Ð¢Ð¸Ð¿ Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ°"
        value={documentType}
        onChange={(e) => setDocumentType(e.target.value)}
        style={{ display: 'block', marginBottom: 10, padding: 8, minWidth: 280 }}
      >
        {MYCAR_DOCUMENT_TYPES.map((type) => (
          <option key={type.value} value={type.value}>
            {type.label}
          </option>
        ))}
      </select>
      <input
        type="file"
        aria-label="ÐÐ¾ÐºÑÐ¼ÐµÐ½Ñ Ð´Ð»Ñ Ð±Ð°Ð½ÐºÐ°"
        onChange={(e) => setFile(e.target.files?.[0] || null)}
        style={{ display: 'block', marginBottom: 10 }}
      />
      <textarea
        aria-label="ÐÐ¾Ð¼Ð¼ÐµÐ½ÑÐ°ÑÐ¸Ð¹ Ð´Ð»Ñ Ð±Ð°Ð½ÐºÐ°"
        placeholder="ÐÐ¾Ð¼Ð¼ÐµÐ½ÑÐ°ÑÐ¸Ð¹ Ð´Ð»Ñ Ð±Ð°Ð½ÐºÐ° (Ð½ÐµÐ¾Ð±ÑÐ·Ð°ÑÐµÐ»ÑÐ½Ð¾)"
        value={comment}
        onChange={(e) => setComment(e.target.value)}
        style={{ display: 'block', width: '100%', maxWidth: 520, minHeight: 60, marginBottom: 10, padding: 8 }}
      />
      <Button
        fill
        disabled={loading}
        onClick={send}
        text={
          loading
            ? 'ÐÑÐ¿ÑÐ°Ð²Ð»ÑÐµÐ¼â¦'
            : 'ÐÑÐ¿ÑÐ°Ð²Ð¸ÑÑ Ð´Ð¾ÑÐ°Ð±Ð¾ÑÐºÑ Ð² MyCar'
        }
      />
    </div>
  );
};

export default MyCarUpdateApplication;
